import { render } from "./AddAttachmentDialog.vue?vue&type=template&id=2a6df534&ts=true"
import script from "./AddAttachmentDialog.vue?vue&type=script&lang=ts"
export * from "./AddAttachmentDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__